import { Box } from '@mui/material';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { FC } from 'react';
import NavigationRail from './NavigationRail';
import MainLayout from './MainLayout';

const DesktopLayout: FC = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                height: '100vh',
                width: '100%',
                backgroundColor: 'primary.main',
            }}
        >
            <NavigationRail />
            <Box
                sx={{
                    backgroundColor: 'surfaceContainerLow.main',
                    height: '100%',
                    borderRadius: theme =>
                        theme.spacing(theme.shape.sm, 0, 0, theme.shape.sm),
                    display: 'flex',
                    flex: 1,
                    minWidth: 0,
                }}
            >
                <MainLayout />
            </Box>
            {import.meta.env.MODE === 'development' &&
                localStorage.dev !== 'off' && (
                    <TanStackRouterDevtools position="bottom-right" />
                )}
        </Box>
    );
};

export default DesktopLayout;
